import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import RequestCall from './RequestCall';
import HomeChooseUs from './HomeChooseUs';
// import OurTeam from './OurTeam';

function About() {
    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) {
                el.style.backgroundImage = `url('/${bg}')`;
            }
        });
    }, []);

    return (
        <>
            {/* <!-- Breadcrumb Section Begin --> */}
            <div className="breadcrumb-option set-bg" data-setbg="img/breadcrumb/brd.webp">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <div className="breadcrumb__text">
                                <h2>About Us</h2>
                                <div className="breadcrumb__links">
                                    <Link to="/">Home</Link>
                                    <span>About</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Breadcrumb Section End --> */}

            {/* <!-- About Section Begin --> */}
            <section className="about spad">
                <div className="container">
                    <div className="about__content">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="about__img">
                                    <img src="img/about/about.jpg" alt="" />
                                    <a href="https://www.youtube.com/watch?v=RpvAmG1NNN0"
                                        className="play-btn video-popup">
                                        <img src="img/about/video-play.png" height="80px" alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 offset-lg-1">
                                <div className="about__text">
                                    <h2>Welcome To Our Financial Services.</h2>
                                    <h4>Your trusted partner for all loan and insurance needs</h4>
                                    <p className="first_para">We are a leading financial services company committed to making
                                        loans and insurance accessible to every individual and business across India.</p>
                                    <p className="last_para">Whether you need a personal loan, a home loan, a business loan,
                                        or the right insurance plan — our team of experts is here to guide you through every
                                        step with complete transparency, speed, and care. We believe every customer deserves
                                        the best financial solution at the lowest possible cost.</p>
                                    <Link to="/contact" className="primary-btn">Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <div className="about__item">
                                <h4>Our Vision</h4>
                                <p>To be India's most trusted financial services partner — empowering individuals and
                                    businesses to achieve their goals through accessible, affordable, and transparent
                                    loan and insurance solutions.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="about__item">
                                <h4>Our Mission</h4>
                                <p>To simplify the loan and insurance process for every customer by offering fast
                                    approvals, competitive interest rates, and dedicated support — from application
                                    to final disbursal.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="about__item">
                                <h4>Our Values</h4>
                                <p>We are built on the pillars of trust, transparency, and customer-first service.
                                    Every decision we make is guided by integrity, speed, and a genuine commitment
                                    to our customers' financial well-being.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- About End --> */}

            {/* <!-- History Section Begin --> */}
            <section className="history spad set-bg" data-setbg="img/history/history-bg.jpg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Our Journey</h2>
                                <p>From a single office to a trusted financial services brand — here's how we grew.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="history__img">
                                <img src="img/history/history-img.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="history__text nice-scroll">
                                <div className="history__item">
                                    <div className="history__indicator"></div>
                                    <span>1st, April 2010</span>
                                    <h4>Founded Our Company</h4>
                                    <p>We started as a small financial consultancy with a mission to help individuals
                                        access personal and business loans quickly and without unnecessary complications.</p>
                                </div>
                                <div className="history__item">
                                    <div className="history__indicator"></div>
                                    <span>15th, June 2015</span>
                                    <h4>Expanded Our Services</h4>
                                    <p>We broadened our portfolio to include Home Loans, Car Loans, Gold Loans,
                                        Loan Against Property, and Credit Card services — becoming a one-stop
                                        financial destination.</p>
                                </div>
                                <div className="history__item">
                                    <div className="history__indicator"></div>
                                    <span>10th, January 2020</span>
                                    <h4>Launched Insurance & Balance Transfer</h4>
                                    <p>To better serve our customers, we added Insurance products and Balance
                                        Transfer / Top-Up loan services, helping thousands save more on their
                                        existing loans.</p>
                                </div>
                                <div className="history__item">
                                    <div className="history__indicator"></div>
                                    <span>Present Day</span>
                                    <h4>Serving 5000+ Happy Customers</h4>
                                    <p>Today, we proudly serve thousands of satisfied customers across India with
                                        a 99% satisfaction rate and a growing team of dedicated financial experts.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- History Section End --> */}

            {/* <!-- Choose Section Begin --> */}
            <HomeChooseUs />
            {/* <!-- Choose Section End --> */}

            {/* <!-- Call Section Begin --> */}
            <RequestCall />
            {/* <!-- Call Section End --> */}
            <br/><br/><br/><br/><br/><br/><br/>
        </>
    );
}

export default About;